// Timeline descriptions as template literals for easy markdown editing
// This approach makes it much easier to edit markdown content with proper syntax highlighting

export const timelineDescriptions = {
  pembentukan: `Pembentukan panitia pemanggilan pendeta ditetapkan berdasarkan:

* Surat Keputusan Majelis GKJ Pamulang No. Kep-30/MG/GKJP/X/2024 tgl 1 Oktober 2024 tentang Pembentukan Panitia Pemanggilan Pendeta Kedua GKJ Pamulang
* Adendum Surat Keputusan Majelis GKJ Pamulang No. Kep-ADD01/MG/GKJP/IV/2025 tgl 1 April 2025 tentang Penambahan Anggota Panitia Pemanggilan Pendeta Kedua GKJ Pamulang`,

  jajak: `Melakukan jajak pendapat kepada jemaat, melalui metode **FGD (Focus Group Discussion)** dimana jemaat dapat memberikan masukan dan saran terkait calon pendeta yang akan diusulkan.

Proses ini memastikan keterlibatan aktif jemaat dalam pemilihan calon pendeta`,

  pemanggilan: `Proses pemanggilan calon pendeta dilaksanakan melalui tahapan berikut:

* Pemanggilan calon pendeta & surat kesanggupan calon Pendeta
* Proses pengecekan kelengkapan administrasi & interview awal
* Pembahasan rencana uji/trial calon pendeta antara Tim dengan Majelis
* Undangan sarasehan visi & misi calon Pendeta kepada jemaat
* Pelaksanaan Sarasehan visi & misi calon Pendeta
* Kotbah Calon Pendeta dalam ibadah minggu`,

  asesmen: `Periode asesmen dan pengenalan lingkungan gereja dilaksanakan melalui tahapan berikut:

* Pelaksanaan tes Kesehatan lengkap
* Pelaksanaan tes Psikologi  
* Interview dan observasi
* Evaluasi hasil tes calon pendeta oleh Majelis dan Tim

**Hasil Evaluasi:** Dari hasil Test Psikologi dan Tes Kesehatan, calon pendeta dinyatakan **Sehat dan Layak** di Calonkan sebagai Calon Pendeta GKJ Pamulang.`,

  pemilihan: `### Pemilihan Calon Pendeta

Pemilihan calon pendeta melalui voting oleh jemaat dengan dasar:

* Keputusan Majelis GKJ Pamulang No.: KEP 11/GKJP/VIII/2025, tanggal 24 Agustus 2025 tentang Pelaksanaan serta Persyaratan dan Ketentuan Pemilihan Calon Pendeta Kedua Gereja Kristen Jawa Pamulang
* Keputusan Majelis GKJ Pamulang No.: KEP 12/GKJP/IX/2025, tanggal 9 September 2025 tentang Daftar Pemilih Tetap (DPT) Pemilihan Calon Pendeta Kedua Gereja Kristen Jawa Pamulang

### Hasil Perhitungan Suara

Adapun hasil perhitungan suara Calon Pendeta GKJ Pamulang dapat kami sampaikan sebagai berikut:

* Terdapat **569** (lima ratus enam puluh sembilan) orang jemaat yang dicatat dalam Daftar Pemilih Tetap (DPT)
* Jemaat yang menggunakan hak pilihnya berjumlah **492** (empat ratus sembilan puluh dua) orang atau **86,4%** dari total DPT, sehingga sesuai ketentuan pemungutan suara ini dinyatakan sah
* Suara **"Setuju"** sebanyak **455** (empat ratus lima puluh lima) suara atau **92,4%** dari total suara
* Suara **"Tidak Setuju"** sebanyak **32** (tiga puluh dua) suara atau **6,5%** dari total suara  
* Suara tidak sah/gugur sebanyak **5** (lima) suara atau **1,0%** dari total suara

Dengan demikian mayoritas **Jemaat Menyatakan Setuju Sdr Faisha Sudarlin, M.Th sebagai Calon Pendeta GKJ Pamulang** dan telah disahkan melalui **Keputusan Majelis GKJ Pamulang No.KEP 13/GKJP/X/2025** tentang Hasil Perhitungan Suara Calon Pendeta Jemaat`,

  pendampingan: `**Tim Pendamping** ditetapkan oleh majelis dan beranggotakan unsur pendeta/pendeta konsulen GKJ Pamulang, penatua, diaken dan warga gereja yang dipandang layak.
Berdasarkan Keputusan No.: **KEP 15/GKJP/X/2025 tanggal 28 Oktober 2025** majelis telah membentuk Tim Pendamping calon pendeta dengan tugas pendampingan dan susunan keanggotaan sebagai berikut:

**Spiritualitas**
* Pdt. Yosua Budiman Harahap, M.Th.
* Pdt. Dr. Agus Hendratmo, MTh

**Kepribadian**
* Dkn. Sumarsih (Majelis)
* Dkn. Wieke Fepie Rusdiana (Majelis)
* Bpk. Winayu Siswanto (Warga Gereja)
* Bpk. Eko Kurnianto (Warga Gereja)
* Ibu Florencia Irena (Warga Gereja)

**Komitmen**
* Pnt. James Munthe (Majelis)
* Dkn. Sussi Widi Kurniasih (Majelis)
* Bpk. Soenoe Harmanto (Warga Gereja)
* Ibu Hanna Chriestina G. (Warga Gereja)

**Kepemimpinan**
* Pnt. Singgih Hujianto (Majelis)
* Dkn. Sulistiandriatmoko (Majelis)
* Bpk. J.E. Mujiono (Warga Gereja)

**Pengelolaan Keuangan**
* Pnt. Leyla Mariana Harmanto (Majelis)
* Pnt. Indrawati Sulistyo Rini (Majelis)

**Tim Pembimbing** 
Sesuai dengan Sidang Klasis JBB Tanggal 22 November 2025, bahwa Tim Pembimbing dan Tim Penguji dari Klasis dalam Proses Pemanggilan Pendeta Jemaat GKJ Pamulang adalah sebagai berikut:

* Pdt. Em. Djoko Sulistyo [GKJ Eben Haezer] - TGTL dan Koordinator
* Pdt. Widianto Nugroho [GKJ Joglo] - Sejarah
* Pdt. Rudy Aryanto [GKJ Eben Haezer] - PPA GKJ
* Pdt. Fransisca Natalia Handayani [GKJ Depok] - Khotbah dan Pastoral.
`,

  ujian: `Ujian komprehensif calon pendeta telah dilaksanakan pada **26 September 2026** sebagai bagian dari proses pemanggilan pendeta kedua GKJ Pamulang.

**Faisha Sudarlin, M.Th. dinyatakan lulus dan layak tahbis** dengan nilai rata-rata **89,55**, berdasarkan Keputusan Sidang Istimewa Gereja-Gereja Kristen Jawa Klasis Jakarta Bagian Barat Nomor **03/SK/KJBB-XXII/IX/2026**.

Materi ujian meliputi khotbah, Pokok-Pokok Ajaran Gereja GKJ, Tata Gereja dan Tata Laksana GKJ, serta sejarah gereja GKJ.`,

  vikariat: `Periode magang dan pembelajaran praktis bagi calon pendeta sebelum pentahbisan resmi.`,

  pentahbisan: `Pentahbisan resmi pendeta kedua GKJ Pamulang. Ini merupakan tahap final dari seluruh proses pemanggilan pendeta.`
};